import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { NotificationService } from 'projects/app-misc/src/app/modules/notification/data/notification.service';
import { UserNotification } from 'projects/app-misc/src/app/modules/notification/data/user-notification';
import * as moment from 'moment';
import * as _ from 'underscore';
import { NotificationsQuery } from 'projects/app-misc/src/app/modules/notification/data/notifications.query';
import { Observable, timer } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'projects/desktop/src/environments/environment';

@Component({
  selector: 'app-notification-page',
  templateUrl: './notification-page.component.html',
  styleUrls: ['./notification-page.component.scss']
})
export class NotificationPageComponent implements OnInit, AfterViewInit {
  start = 0;
  limit = 12;

  totalElements$ = this.notificationsQuery.total;
  notificationMap$: Observable<Map<string, UserNotification[]>>;

  constructor(
    protected el: ElementRef,
    protected notificationService: NotificationService,
    protected notificationsQuery: NotificationsQuery
  ) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    timer(1).subscribe(emit => {
      this.limit = Math.trunc((this.el.nativeElement.offsetHeight - environment.bottomOfSet) / 80);


      this.notificationMap$ = this.notificationsQuery
      .selectAll()
      .pipe(
        map(notifications => {
          const notificationMap = new Map<string, UserNotification[]>()
          notifications.forEach(usernotification => {
            const key = moment(usernotification.notification.createdTime).format('L')
            if(!notificationMap.has(key)) {
              notificationMap.set(key, [])
            }
            notificationMap.get(key).push(usernotification)
          })

          // _.groupBy(notifications, notification => moment(notification.createdTime).format('L')

          return notificationMap
        })
      )

      this.loadNotifications(this.start, this.limit)
    })
  }

  markAllAsRead() {
    this.notificationService
    .markAllNfsAsRead()
    .subscribe()
  }

  returnZero() {
    return 0
  }

  loadNotifications(start: number, limit: number) {
    this.notificationService.loadNotifications(start, limit)
  }

  // FIXME: use type
  onPageChange(event) {
    this.loadNotifications(event.page, event.rows)
  }
}
